import { useApolloClient } from '@apollo/client';
import { useCallback, useEffect, useRef } from 'react';
import type { QuotationUpdatedSubscription, QuotationUpdatedSubscriptionVariables } from '../api';
import { QuotationUpdatedDocument } from '../api';

export type QuotationUpdateHandlerProps = {
    purchaseTransactionId: string;
    onUpdate: (quotationUpdated: QuotationUpdatedSubscription['quotationUpdated']) => void;
};

const QuotationUpdateHandler = ({ purchaseTransactionId, onUpdate }: QuotationUpdateHandlerProps) => {
    const apolloClient = useApolloClient();

    const messageHandler = useCallback(
        (message: QuotationUpdatedSubscription['quotationUpdated']) => {
            onUpdate(message);
        },
        [onUpdate]
    );

    const messageHandlerRef = useRef(messageHandler);

    messageHandlerRef.current = messageHandler;

    useEffect(() => {
        const observer = apolloClient.subscribe<QuotationUpdatedSubscription, QuotationUpdatedSubscriptionVariables>({
            query: QuotationUpdatedDocument,
            variables: { purchaseTransactionId },
        });

        const subscription = observer.subscribe(({ data }) => {
            if (data?.quotationUpdated) {
                messageHandlerRef.current(data.quotationUpdated);
            }
        });

        return () => subscription.unsubscribe();
    }, [apolloClient, messageHandlerRef, purchaseTransactionId]);

    return null;
};

export default QuotationUpdateHandler;
